
import { UserModel } from '@/typings';
import { defineComponent, PropType } from 'vue';
import { RouterLink } from 'vue-router';

export default defineComponent({
    components: {
        RouterLink
    },
    props: {
        user: {
            type: Object as PropType<Pick<UserModel, '_id' | 'name'>>,
            required: true
        },
        full: {
            type: Number,
            default: 0
        }
    }

});

